import { http, HttpResponse } from "msw";

import { STATUS_PAGE_RESPONSE } from "../data/status-page";

/**
 * msw handlers for endpoints the router app itself owns (not tech-ui,
 * which lives in another repo but executes inside this document — see
 * `./tech-ui.ts`).
 */
const routerHandlers = [
  // External status widget.
  http.get("*/opcenter/live-status", () =>
    HttpResponse.json(STATUS_PAGE_RESPONSE)
  ),
];

export { routerHandlers };
